// src/pages/TrainerDashboard.js
import React, { useCallback, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';
import DashboardShell from '../components/dashboard/DashboardShell';
import TrainingQuickListCard from '../components/dashboard/trainer/TrainingQuickListCard';
import TrainerTrainingsTable from '../components/dashboard/trainer/TrainerTrainingsTable';
import { getUser } from '../utils/auth';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function TrainerDashboard() {
  const user = getUser();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStats = useCallback(async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/stat/get_trainer_dashboard.php`, {
        withCredentials: true
      });
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching trainer dashboard:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <DashboardShell title={`Welcome, ${user.name}`} subtitle="Your assigned trainings">
      <Row className="g-3 mb-1">
        <Col md={6}>
          <TrainingQuickListCard
            title="Upcoming Sessions (next 30 days)"
            icon="bi-calendar-event"
            count={stats?.upcomingCount ?? 0}
            items={stats?.upcomingSessions ?? []}
            loading={loading}
            emptyMessage="No sessions in the next 30 days."
          />
        </Col>
        <Col md={6}>
          <TrainingQuickListCard
            title="Attendance Not Yet Submitted"
            icon="bi-exclamation-triangle"
            count={stats?.pendingAttendanceCount ?? 0}
            items={stats?.pendingAttendance ?? []}
            loading={loading}
            emptyMessage="Nothing pending — all caught up."
          />
        </Col>
      </Row>
      <Row className="g-3 mt-1">
        <Col md={12}>
          <TrainerTrainingsTable trainings={stats?.allTrainings ?? []} loading={loading} onStatusChanged={fetchStats} />
        </Col>
      </Row>
    </DashboardShell>
  );
}

export default TrainerDashboard;
